// extracted by mini-css-extract-plugin
module.exports = {"root":"TopBar_root__1G3vY","brand":"TopBar_brand__J00Rf","brandName":"TopBar_brandName__3Uvpf","hasScrolled":"TopBar_hasScrolled__1R-6t"};